// extracted by mini-css-extract-plugin
export default {"inputActions":"DadataMultiSelectInput_inputActions__+tQL3"};